export default __webpack_public_path__ + "static/Gotham-Book-331584741de22bd7f63f5bc29f4af5ab.woff";